import React from 'react'
import Application from '../../../../../assets/svg/Application'
import Communication from '../../../../../assets/svg/Communication'
import Elec from '../../../../../assets/svg/Elec'
import Filter from '../../../../../assets/svg/Filter'
import Fire from '../../../../../assets/svg/Fire'
import Search from '../../../../../assets/svg/search'
import Sort from '../../../../../assets/svg/Sort'
import Water from '../../../../../assets/svg/Water'
import { trans } from '../../../../../Internationalization'
function CompaniesIcon(props) {
  const showIcon = () => {
    switch (props.view) {
      case "Electricty Companies":
        return <>  <Elec active={true} /></>
      case "Water Companies":
        return <> <Water active={true} /></>
      case "Gas Companies":
        return <><Fire active={true} /></>
      case "Communications Companies":
        return <><Communication active={true} /></>
      default:
        return <> <svg id="_15x15_photo_back" data-name="15x15 photo back" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15">
          <g id="Mask_Group_141" data-name="Mask Group 141">
            <path id="nanotechnology" d="M15.242,7.742a1.207,1.207,0,0,0-1.08-1.2,6.535,6.535,0,0,0-1.034-2.5,1.2,1.2,0,0,0-1.692-1.693,6.534,6.534,0,0,0-2.5-1.035,1.2,1.2,0,0,0-2.393,0,6.534,6.534,0,0,0-2.5,1.035A1.2,1.2,0,0,0,2.357,4.049a6.533,6.533,0,0,0-1.034,2.5,1.2,1.2,0,0,0,0,2.393,6.535,6.535,0,0,0,1.034,2.5,1.2,1.2,0,0,0,1.692,1.693,6.536,6.536,0,0,0,2.5,1.035,1.2,1.2,0,0,0,2.393,0,6.537,6.537,0,0,0,2.5-1.035,1.2,1.2,0,0,0,1.692-1.693,6.535,6.535,0,0,0,1.034-2.5,1.207,1.207,0,0,0,1.08-1.2Zm-3.81,3.513-1.182-1a1.137,1.137,0,0,0,.131-.791l2.642-1.057a1.21,1.21,0,0,0,.655.486,6.048,6.048,0,0,1-.926,2.233,1.2,1.2,0,0,0-1.32.129Zm-7.283.08a1.211,1.211,0,0,0-.2-.16l.988-2.963a1.163,1.163,0,0,0,.143.015,1.2,1.2,0,0,0,.862-.364L8.069,9.238a1.171,1.171,0,0,0-.057.695L4.321,11.557a1.207,1.207,0,0,0-.172-.222Zm-1.418-.209a6.048,6.048,0,0,1-.926-2.233,1.207,1.207,0,0,0,.855-1.146l1.305-.261a1.212,1.212,0,0,0,.512.573L3.5,11a1.207,1.207,0,0,0-.766.125ZM3.294,4.5a1.211,1.211,0,0,0,.324-.05l.744,1.6a1.2,1.2,0,0,0-.491.963l-1.305.261a1.212,1.212,0,0,0-.761-.681,6.048,6.048,0,0,1,.925-2.233,1.209,1.209,0,0,0,.563.145Zm.855-.354a1.222,1.222,0,0,0,.144-.175L7.518,5.146a1.177,1.177,0,0,0-.018.176,1.207,1.207,0,0,0,.036.281L6.048,6.3A1.181,1.181,0,0,0,4.8,5.843L4.048,4.232a1.159,1.159,0,0,0,.1-.082Zm7.185,0a1.194,1.194,0,0,0,1.418.209,6.05,6.05,0,0,1,.926,2.233,1.208,1.208,0,0,0-.622.442L9.887,5.592a1.219,1.219,0,0,0,.032-.269,1.193,1.193,0,0,0-.066-.375l1.454-.831c.01.01.017.023.027.033ZM9.3,8.479,9.08,6.468a1.207,1.207,0,0,0,.6-.436l3.17,1.441a1.1,1.1,0,0,0-.011.484L10.2,9.013a1.207,1.207,0,0,0-.9-.534ZM8.6,6.521l.223,2.011a1.207,1.207,0,0,0-.491.3L6.2,7.455a1.147,1.147,0,0,0,.049-.72l1.488-.694a1.2,1.2,0,0,0,.858.48Zm.293-4.716a6.054,6.054,0,0,1,2.233.925,1.16,1.16,0,0,0-.07.973l-1.441.824a1.2,1.2,0,0,0-.9-.414c-.018,0-.034,0-.052.005l-.395-1.58a1.209,1.209,0,0,0,.63-.733Zm-1.151.856c.018,0,.034,0,.052-.005l.395,1.58a1.212,1.212,0,0,0-.506.456l-3.2-1.164A1.226,1.226,0,0,0,4.5,3.294a1.2,1.2,0,0,0-.145-.563,6.05,6.05,0,0,1,2.233-.925,1.208,1.208,0,0,0,1.151.856ZM6.591,13.678a6.051,6.051,0,0,1-2.233-.925A1.2,1.2,0,0,0,4.5,12.19a1.23,1.23,0,0,0-.017-.177l3.722-1.638a1.212,1.212,0,0,0,.382.345l-.706,2.117a1.221,1.221,0,0,0-.143-.014,1.207,1.207,0,0,0-1.151.856Zm1.753-.689.706-2.117a1.163,1.163,0,0,0,.143.015,1.2,1.2,0,0,0,.744-.263l1.187,1a1.166,1.166,0,0,0,0,1.125,6.051,6.051,0,0,1-2.233.925,1.208,1.208,0,0,0-.548-.689Z" transform="translate(-0.242 -0.242)" fill="#8e8e8e" />
          </g>
        </svg></>
        break;
    }
  }
  return (
    //     <div style={{marginRight:"20px", display:"flex"}} className={'icon-lang communication'+` ${props.active&& "active-com-h"}`}>

    //           <div className='nano'>
    //           <svg className={`${props.active&&"activated-hrm"}`} id="_15x15_photo_back" data-name="15x15 photo back" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15">
    //   <g id="Mask_Group_141" data-name="Mask Group 141">
    //     <path id="nanotechnology" d="M15.242,7.742a1.207,1.207,0,0,0-1.08-1.2,6.535,6.535,0,0,0-1.034-2.5,1.2,1.2,0,0,0-1.692-1.693,6.534,6.534,0,0,0-2.5-1.035,1.2,1.2,0,0,0-2.393,0,6.534,6.534,0,0,0-2.5,1.035A1.2,1.2,0,0,0,2.357,4.049a6.533,6.533,0,0,0-1.034,2.5,1.2,1.2,0,0,0,0,2.393,6.535,6.535,0,0,0,1.034,2.5,1.2,1.2,0,0,0,1.692,1.693,6.536,6.536,0,0,0,2.5,1.035,1.2,1.2,0,0,0,2.393,0,6.537,6.537,0,0,0,2.5-1.035,1.2,1.2,0,0,0,1.692-1.693,6.535,6.535,0,0,0,1.034-2.5,1.207,1.207,0,0,0,1.08-1.2Zm-3.81,3.513-1.182-1a1.137,1.137,0,0,0,.131-.791l2.642-1.057a1.21,1.21,0,0,0,.655.486,6.048,6.048,0,0,1-.926,2.233,1.2,1.2,0,0,0-1.32.129Zm-7.283.08a1.211,1.211,0,0,0-.2-.16l.988-2.963a1.163,1.163,0,0,0,.143.015,1.2,1.2,0,0,0,.862-.364L8.069,9.238a1.171,1.171,0,0,0-.057.695L4.321,11.557a1.207,1.207,0,0,0-.172-.222Zm-1.418-.209a6.048,6.048,0,0,1-.926-2.233,1.207,1.207,0,0,0,.855-1.146l1.305-.261a1.212,1.212,0,0,0,.512.573L3.5,11a1.207,1.207,0,0,0-.766.125ZM3.294,4.5a1.211,1.211,0,0,0,.324-.05l.744,1.6a1.2,1.2,0,0,0-.491.963l-1.305.261a1.212,1.212,0,0,0-.761-.681,6.048,6.048,0,0,1,.925-2.233,1.209,1.209,0,0,0,.563.145Zm.855-.354a1.222,1.222,0,0,0,.144-.175L7.518,5.146a1.177,1.177,0,0,0-.018.176,1.207,1.207,0,0,0,.036.281L6.048,6.3A1.181,1.181,0,0,0,4.8,5.843L4.048,4.232a1.159,1.159,0,0,0,.1-.082Zm7.185,0a1.194,1.194,0,0,0,1.418.209,6.05,6.05,0,0,1,.926,2.233,1.208,1.208,0,0,0-.622.442L9.887,5.592a1.219,1.219,0,0,0,.032-.269,1.193,1.193,0,0,0-.066-.375l1.454-.831c.01.01.017.023.027.033ZM9.3,8.479,9.08,6.468a1.207,1.207,0,0,0,.6-.436l3.17,1.441a1.1,1.1,0,0,0-.011.484L10.2,9.013a1.207,1.207,0,0,0-.9-.534ZM8.6,6.521l.223,2.011a1.207,1.207,0,0,0-.491.3L6.2,7.455a1.147,1.147,0,0,0,.049-.72l1.488-.694a1.2,1.2,0,0,0,.858.48Zm.293-4.716a6.054,6.054,0,0,1,2.233.925,1.16,1.16,0,0,0-.07.973l-1.441.824a1.2,1.2,0,0,0-.9-.414c-.018,0-.034,0-.052.005l-.395-1.58a1.209,1.209,0,0,0,.63-.733Zm-1.151.856c.018,0,.034,0,.052-.005l.395,1.58a1.212,1.212,0,0,0-.506.456l-3.2-1.164A1.226,1.226,0,0,0,4.5,3.294a1.2,1.2,0,0,0-.145-.563,6.05,6.05,0,0,1,2.233-.925,1.208,1.208,0,0,0,1.151.856ZM6.591,13.678a6.051,6.051,0,0,1-2.233-.925A1.2,1.2,0,0,0,4.5,12.19a1.23,1.23,0,0,0-.017-.177l3.722-1.638a1.212,1.212,0,0,0,.382.345l-.706,2.117a1.221,1.221,0,0,0-.143-.014,1.207,1.207,0,0,0-1.151.856Zm1.753-.689.706-2.117a1.163,1.163,0,0,0,.143.015,1.2,1.2,0,0,0,.744-.263l1.187,1a1.166,1.166,0,0,0,0,1.125,6.051,6.051,0,0,1-2.233.925,1.208,1.208,0,0,0-.548-.689Z" transform="translate(-0.242 -0.242)" fill="#8e8e8e"/>
    //   </g>
    // </svg>
    //             </div> 
    //     <div className='icon-lang-desc' style={{right:"10px", left:"initial"}}>
    //       <svg style={{left:"initial",right:"5px"}} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    //       <defs>
    //         <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
    //           <feOffset dy="3" input="SourceAlpha"/>
    //           <feGaussianBlur stdDeviation="3" result="blur"/>
    //           <feFlood floodOpacity="0.2"/>
    //           <feComposite operator="in" in2="blur"/>
    //           <feComposite in="SourceGraphic"/>
    //         </filter>
    //       </defs>
    //       <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
    //         <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040"/>
    //       </g>
    //     </svg>
    //   <div  className='icon-lang-desc-bu' style={{left:"initial",right:"-76px", width:"150px"}}>Services Companies</div>
    //       </div>
    //       <div className='com-top-list'>
    //   <div onClick={()=>props.change("Electricty Companies")} className={'com-top-item'+` ${props.view==="Electricty Companies" && "active-com"}`}>
    //   <div className='icon-lang-desc'>
    //       <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    //       <defs>
    //         <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
    //           <feOffset dy="3" input="SourceAlpha"/>
    //           <feGaussianBlur stdDeviation="3" result="blur"/>
    //           <feFlood floodOpacity="0.2"/>
    //           <feComposite operator="in" in2="blur"/>
    //           <feComposite in="SourceGraphic"/>
    //         </filter>
    //       </defs>
    //       <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
    //         <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040"/>
    //       </g>
    //     </svg>
    //   <div className='icon-lang-desc-bu hst contries'>Electricty Companies</div>
    //       </div>
    //     <Elec/></div>
    //   <div onClick={()=>props.change("Gas Companies")} className={'com-top-item'+` ${props.view==="Gas Companies" && "active-com"}`}>
    //   <div className='icon-lang-desc'>
    //       <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    //       <defs>
    //         <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
    //           <feOffset dy="3" input="SourceAlpha"/>
    //           <feGaussianBlur stdDeviation="3" result="blur"/>
    //           <feFlood floodOpacity="0.2"/>
    //           <feComposite operator="in" in2="blur"/>
    //           <feComposite in="SourceGraphic"/>
    //         </filter>
    //       </defs>
    //       <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
    //         <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040"/>
    //       </g>
    //     </svg>
    //   <div className='icon-lang-desc-bu hst contries'>Gas Companies</div>
    //       </div>
    //     <Fire/></div>
    //   <div onClick={()=>props.change("Water Companies")} className={'com-top-item'+` ${props.view==="Water Companies" && "active-com"}`}>
    //   <div className='icon-lang-desc'>
    //       <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    //       <defs>
    //         <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
    //           <feOffset dy="3" input="SourceAlpha"/>
    //           <feGaussianBlur stdDeviation="3" result="blur"/>
    //           <feFlood floodOpacity="0.2"/>
    //           <feComposite operator="in" in2="blur"/>
    //           <feComposite in="SourceGraphic"/>
    //         </filter>
    //       </defs>
    //       <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
    //         <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040"/>
    //       </g>
    //     </svg>
    //   <div className='icon-lang-desc-bu hst contries'>Water Companies</div>
    //       </div>
    //     <Water/></div>
    //   <div onClick={()=>props.change("Communications Companies")} className={'com-top-item'+` ${props.view==="Communications Companies" && "active-com"}`}>
    //   <div className='icon-lang-desc'>
    //       <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    //       <defs>
    //         <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
    //           <feOffset dy="3" input="SourceAlpha"/>
    //           <feGaussianBlur stdDeviation="3" result="blur"/>
    //           <feFlood floodOpacity="0.2"/>
    //           <feComposite operator="in" in2="blur"/>
    //           <feComposite in="SourceGraphic"/>
    //         </filter>
    //       </defs>
    //       <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
    //         <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040"/>
    //       </g>
    //     </svg>
    //   <div className='icon-lang-desc-bu hst contries'>Communications Companies</div>
    //       </div>
    //     <Communication/></div>
    // </div>  


    // </div>
    <>
      <div className='top-options counts'>
        <div className='top-option langs sas'>

          <div className='lang-items cvf'>
            <div onClick={() => props.change("Electricty Companies")} className={'com-top-item' + ` ${props.view === "Electricty Companies" && "active-com"}`}>
              <div className='icon-lang-desc' style={{ left: "initial", right: "100px", top: "0px", position: "fixed" }}>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
                  <defs>
                    <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="3" result="blur" />
                      <feFlood floodOpacity="0.2" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
                    <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040" />
                  </g>
                </svg>
                <div className='icon-lang-desc-bu hst contries' style={{ left: "-277%" }} >{trans("elect_comp")}</div>
              </div>
              <Elec />
            </div>
            <div onClick={() => props.change("Water Companies")} className={'com-top-item' + ` ${props.view === "Water Companies" && "active-com"}`}>
              <div className='icon-lang-desc' style={{ left: "initial", right: "74px", top: "0px", position: "fixed" }}>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
                  <defs>
                    <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="3" result="blur" />
                      <feFlood floodOpacity="0.2" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
                    <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040" />
                  </g>
                </svg>
                <div className='icon-lang-desc-bu hst contries' style={{ left: "-277%" }}>{trans("wat_comp")}</div>
              </div>
              <Water />
            </div>
            <div onClick={() => props.change("Gas Companies")} className={'com-top-item' + ` ${props.view === "Gas Companies" && "active-com"}`}>
              <div className='icon-lang-desc' style={{ left: "initial", right: "50px", top: "0px", position: "fixed" }}>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
                  <defs>
                    <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="3" result="blur" />
                      <feFlood floodOpacity="0.2" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
                    <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040" />
                  </g>
                </svg>
                <div className='icon-lang-desc-bu hst contries' style={{ left: "-277%" }}>{trans("gas_comp")}</div>
              </div>
              <Fire />
            </div>
            <div onClick={() => props.change("Communications Companies")} className={'cva com-top-item' + ` ${props.view === "Communications Companies" && "active-com"}`}>
              <div className='icon-lang-desc' style={{ left: "initial", right: "25px", top: "0px", position: "fixed" }}>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
                  <defs>
                    <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="3" result="blur" />
                      <feFlood floodOpacity="0.2" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
                    <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040" />
                  </g>
                </svg>
                <div className='icon-lang-desc-bu hst contries' style={{ left: "-277%" }}>{trans("comm_comp")}</div>
              </div>
              <Communication />
            </div>
          </div>
          <span className='l' style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: "20px" }} className='icon-lang'>

              <div className='icon-lang-desc' style={{ position: "fixed", right: "9px", top: "0px", left: "initial" }}>
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
                  <defs>
                    <filter id="Ellipse_319" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse">
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="3" result="blur" />
                      <feFlood floodOpacity="0.2" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Ellipse_319)">
                    <circle id="Ellipse_319-2" data-name="Ellipse 319" cx="3" cy="3" r="3" transform="translate(9 6)" fill="#404040" />
                  </g>
                </svg>
                <div className='icon-lang-desc-bu hst contries'>{trans("services")}</div>
              </div>

              {showIcon()}
            </div>
          </span>
        </div>
      </div>
    </>
  )
}

export default CompaniesIcon